module.exports = __webpack_public_path__ + "static/media/success.84a407b0.gif";